/* Section-local enhancement; Shopify's native product pages handle variants and checkout. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-cn-coffee]').forEach(section => {
      if (section.dataset.cnReady) return;
      section.dataset.cnReady = 'true';
      const cards = [...section.querySelectorAll('[data-cn-card]')];
      if (!cards.length) return;
      section.querySelectorAll('[data-cn-controls]').forEach(el => el.hidden = false);
      const status = section.querySelector('.cn-filter-status');
      let activeFilter = 'all';
      const mobile = window.matchMedia('(max-width: 760px)');
      function updateCards() {
        const limit = Number(mobile.matches ? section.dataset.cnMobileLimit : section.dataset.cnDesktopLimit) || (mobile.matches ? 4 : 6);
        let shown = 0;
        const matching = cards.filter(card => activeFilter === 'all' || card.dataset.cnKind === activeFilter);
        cards.forEach(card => {
          const matches = activeFilter === 'all' || card.dataset.cnKind === activeFilter;
          card.hidden = !matches || shown >= limit;
          if (!card.hidden) shown++;
        });
        status.textContent = shown ? `${shown} of ${matching.length} coffees shown.` : 'No coffees in this group. Try All favourites.';
        status.classList.toggle('visually-hidden', shown > 0);
      }
      section.querySelectorAll('[data-cn-filter]').forEach(button => button.addEventListener('click', () => {
        activeFilter = button.dataset.cnFilter;
        section.querySelectorAll('[data-cn-filter]').forEach(b => {
          b.classList.toggle('active', b === button);
          b.setAttribute('aria-pressed', String(b === button));
        });
        updateCards();
      }));
      const onResize = () => updateCards();
      mobile.addEventListener('change', onResize);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(section)) mobile.removeEventListener('change', onResize);
      });
      updateCards();
      const dialog = section.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        let opener;
        section.querySelectorAll('[data-cn-preview]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            const template = [...section.querySelectorAll('template[data-cn-template]')].find(t => t.dataset.cnTemplate === button.dataset.cnPreview);
            if (!template) return;
            opener = button;
            dialog.querySelector('[data-cn-dialog-content]').replaceChildren(template.content.cloneNode(true));
            dialog.showModal();
          });
        });
        dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => opener?.focus());
        dialog.addEventListener('click', e => {
          if (e.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
        });
      }
      section.querySelector('[data-cn-match]')?.addEventListener('click', () => {
        const id = section.querySelector('[data-cn-preference]').value;
        const card = cards.find(c => c.dataset.cnCard === id);
        if (!card) return;
        const source = card.querySelector('[data-cn-title]');
        const result = section.querySelector('.cn-finder-result');
        const title = document.createElement('strong');
        title.textContent = `Start with ${source.textContent.trim()}. `;
        const link = document.createElement('a');
        link.className = 'text-link'; link.href = source.href; link.textContent = 'Explore this coffee';
        result.replaceChildren(title, link); result.hidden = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
